import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Navbar.css";

function Navbar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const currentLanguage =
    i18n.resolvedLanguage === "en" ||
    i18n.language?.startsWith("en")
      ? "en"
      : "ar";

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);

    document.documentElement.lang = language;
    document.documentElement.dir =
      language === "ar" ? "rtl" : "ltr";
  };

  const links = [
    { key: "home", path: "/" },
    { key: "about", path: "/about" },
    { key: "services", path: "/services" },
    { key: "courses", path: "/courses" },
    { key: "trainers", path: "/trainers" },
    { key: "achievements", path: "/achievements" },
    { key: "contact", path: "/contact" },
  ];

  // ================= LOGO =================

  const logo =
    "https://i.postimg.cc/cLRvTDG3/Whats-App-Image-2026-08-27-at-4-44-34-AM.jpg";

  return (
    <>
      {/* ================= NAVBAR ================= */}

      <header className="navbar">
        <div className="nav-container">

          {/* ================= LOGO ================= */}

          <Link
            to="/"
            className="brand"
            onClick={() => setOpen(false)}
            aria-label="Medad Learning Hub"
          >
            <img
              src={logo}
              alt="Medad Learning Hub"
              className="brand-logo"
            />
          </Link>

          {/* ================= DESKTOP NAV ================= */}

          <nav className="desktop-nav">

            {links.map((link) => {
              const active =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path);

              return (
                <Link
                  key={link.key}
                  to={link.path}
                  className={active ? "active-link" : ""}
                >
                  {t(`nav.${link.key}`)}
                </Link>
              );
            })}

            {/* REGISTER */}

            <Link
              to="/registration"
              className="register-link"
            >
              {t("nav.register")}
            </Link>

            {/* ================= DESKTOP LANGUAGE ================= */}

            <div className="language desktop-language">

              <button
                type="button"
                className={
                  currentLanguage === "ar"
                    ? "selected"
                    : ""
                }
                onClick={() => changeLanguage("ar")}
              >
                عربي
              </button>

              <span>|</span>

              <button
                type="button"
                className={
                  currentLanguage === "en"
                    ? "selected"
                    : ""
                }
                onClick={() => changeLanguage("en")}
              >
                EN
              </button>

            </div>

          </nav>

          {/* ================= MOBILE BUTTON ================= */}

          <button
            type="button"
            className="menu-button"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            <span />
            <span />
            <span />
          </button>

        </div>
      </header>

      {/* ================= OVERLAY ================= */}

      {open && (
        <div
          className="nav-overlay"
          onClick={() => setOpen(false)}
        />
      )}

      {/* ================= MOBILE SIDEBAR ================= */}

      <aside
        className={`mobile-sidebar ${
          open ? "sidebar-open" : ""
        }`}
      >

        {/* ================= SIDEBAR HEADER ================= */}

        <div className="sidebar-top">

          <Link
            to="/"
            className="sidebar-brand"
            onClick={() => setOpen(false)}
          >
            <img
              src={logo}
              alt="Medad Learning Hub"
              className="sidebar-logo"
            />
          </Link>

          <button
            type="button"
            className="close-menu"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>

        </div>

        {/* ================= SIDEBAR LINKS ================= */}

        <div className="sidebar-links">

          {links.map((link) => {

            const active =
              link.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(link.path);

            return (
              <Link
                key={link.key}
                to={link.path}
                className={active ? "active-link" : ""}
                onClick={() => setOpen(false)}
              >
                {t(`nav.${link.key}`)}
              </Link>
            );
          })}

          {/* REGISTER */}

          <Link
            to="/registration"
            className="register-link"
            onClick={() => setOpen(false)}
          >
            {t("nav.register")}
          </Link>

        </div>

        {/* ================= MOBILE LANGUAGE ================= */}

        <div className="mobile-language">

          <p>
            {currentLanguage === "ar"
              ? "اختر اللغة"
              : "Choose Language"}
          </p>

          <div className="mobile-language-buttons">

            <button
              type="button"
              className={
                currentLanguage === "ar"
                  ? "selected"
                  : ""
              }
              onClick={() => {
                changeLanguage("ar");
              }}
            >
              عربي
            </button>

            <button
              type="button"
              className={
                currentLanguage === "en"
                  ? "selected"
                  : ""
              }
              onClick={() => {
                changeLanguage("en");
              }}
            >
              EN
            </button>

          </div>

        </div>

      </aside>
    </>
  );
}

export default Navbar;